function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "7Hd32L",
  x1: 0.27,
  x2: 0.76,
  y1: 0.1,
  y2: 1.11,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffdea1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffa99e"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#7Hd32L)",
  d: "M22.03 36.12a20.81 20.81 0 0 1-7.68-1.48l-2.33-.93V12.04l4.5-8.94a5.26 5.26 0 0 1 4.6-3.1 2.52 2.52 0 0 1 .26.01 3.19 3.19 0 0 1 2.5 3.59l-.73 9.65 7.27-.58a5.11 5.11 0 0 1 1.6.13c3.28.78 5.41 4.58 4.76 8.5l-1.52 9.02c-.57 3.37-3.06 5.8-5.96 5.8ZM1.8 34.45A1.93 1.93 0 0 1 0 32.42V14.09a1.93 1.93 0 0 1 1.8-2.03h5.4A1.93 1.93 0 0 1 9 14.09v18.33a1.93 1.93 0 0 1-1.8 2.03Z",
  transform: "translate(3.5 6)"
});

function SvgThumbsUpActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpActive);
export default __webpack_public_path__ + "static/media/thumbs-up-active.4f8a7dcf.svg";
export { ForwardRef as ReactComponent };